import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { commonComponentImages } from '@images/common-components-images';
import { commonImages } from '@images/common-images';
import { DashService } from '@modules/dash-board/dash.service';
import { LeadManagementService } from '@services/lm-service/lead-management.service';
import { ToasterService } from '@services/util/toaster.service';

@Component({
  selector: 'app-collapse-box',
  templateUrl: './collapse-box.component.html',
  styleUrls: ['./collapse-box.component.scss'],
})
export class CollapseBoxComponent implements OnInit {
  @Input() isCollapsed: boolean = false;
  showMoreExpanded: boolean = false;
  @Input() headingClassName: string = '';
  @Input() plusClassName: string = '';
  @Input() background: boolean = false;
  @Input() icon_style: boolean = false;
  @Input() cardBodyPadding: string = '';
  @Input() contractBorder: string = '';
  @Input() cardBorder: string = '';
  @Input() cardHeader: string = '';
  @Input() border: string = '';
  @Input() heading: string = 'Heading';
  @Input() AddNew: boolean = false;
  @Input() cardpadding: boolean = false;
  @Input() bgwhite: boolean = false;
  @Input() isContact: any;
  @Input() isLeadContact: any;
  @Input() isFromLead: boolean = false;
  @Input() IsExpandedHorizontally: boolean = false;
  @Input() MaxHeight: string = 'auto';
  @Input() padding: boolean = false;
  // When true, clicking the header body emits an 'edit-<heading>' action
  // instead of collapsing; only the chevron icon toggles show/hide.
  @Input() editOnHeaderClick: boolean = false;

  @Output() TriggerAction: EventEmitter<string> = new EventEmitter<string>();
  common_images = commonImages;

  constructor(
    public lmService: LeadManagementService,
    private dash: DashService,
    private _toasterService: ToasterService
  ) {}

  mobToggle = false;
  images = commonComponentImages;

  ngOnInit(): void {
    this.dash?.screenSize$?.subscribe(size => {
      if (size.width < 567) {
        this.mobToggle = true;
      } else {
        this.mobToggle = false;
      }
    });
  }

  openContactPopup(lead, event) {
    event.stopPropagation();
    this.lmService.isEdit_show_div = 'edit_contact';
    if (this.isFromLead == true && lead?.contactid == null) {
      this._toasterService.Error('Contact not found');
      return false;
    }
    lead['_id'] = lead?.contactid ? lead?.contactid : lead?._id;
    let name = lead?.contact?.full_name ? lead?.contact?.full_name : lead?.full_name ? lead?.full_name : '';
    this.lmService.addTabInLevels(`Contact-${name}`, lead?.contactid, lead);
  }

  message = 'expanded';
  toggleCollapse() {
    this.TriggerAction.emit(this.isCollapsed ? 'opened-' + this.heading : 'closed-' + this.heading);
    this.isCollapsed = !this.isCollapsed;
  }

  // Header body click: edit when opted in, otherwise toggle (default behaviour).
  // Editing also expands the box — empty sections start collapsed, and the
  // fields the user clicked to fill in must be visible.
  onHeaderClick() {
    if (this.editOnHeaderClick) {
      this.TriggerAction.emit('edit-' + this.heading);
      this.isCollapsed = false;
    } else {
      this.toggleCollapse();
    }
  }

  // Chevron icon always toggles show/hide; stop bubbling so the header
  // click doesn't also fire (edit/toggle) for the same click.
  onChevronClick(event: Event) {
    event?.stopPropagation();
    this.toggleCollapse();
  }

  collapsed(): void {
    this.message = 'collapsed';
  }

  collapses(): void {
    this.message = 'collapses';
  }

  expanded(): void {
    this.message = 'expanded';
  }

  expands(): void {
    this.message = 'expands';
  }

  onClickEmitEventHandler(event) {
    event?.stopPropagation();
    this.TriggerAction.emit(this.heading);
    this.isCollapsed = false;
  }
}
